import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { SystemService } from 'src/app/services/system.service';
import { CookieService } from 'ngx-cookie-service';
import * as theGlobals from 'src/app/shared/globals';
import { MsalService } from '@azure/msal-angular';
import { LoggedInUserDto } from 'src/app/shared/dto/LoggedInUserDto';
import { EventEmitterService} from "./services/event-emitter.service";

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html'
})
export class AppTopbarComponent implements OnInit {
    @Input() secLevel: number;

    isLoggedIn = false;
    needEmailVerify = false;
    needAamsAuth = true;
    didAamsAuthCheck = false;
    // define the Authorization Provider (Auth0, Azure Active Directory, other??)
    authProvider = theGlobals.setEnv().authProvider;
    allowCaseBackload = theGlobals.allowCaseBackload ?? false;

    constructor(private router: Router,
                private utilService: UtilitiesService,
                private cookieService: CookieService,
                private msalService: MsalService,
                private systemService: SystemService,
                private _myUser: LoggedInUserDto,
                private eventEmitter: EventEmitterService,
        ) {}

    ngOnInit() {
        this.utilService.doAudit(this.secLevel, 'topbar onInit; sec level:');
        this.useAzureAD();
   }

    useAzureAD() {
      this.utilService.doAudit('', 'useAzureAD start...');
      const user = this.msalService.instance.getActiveAccount();
      this.utilService.doAudit(user, 'topbar; useAzureAD entry point:');
      if (user) {
        this.needEmailVerify = false;
        const userName = user.username;
        let validUser;
        this.utilService.doAudit(userName, 'validating user:');
        this.systemService.validateUser(userName).subscribe(data => {
          this.utilService.doAudit(data, 'response from validator:');
          this.didAamsAuthCheck = true;
          if (data == null) {
              alert('You are not defined as a valid AAMS user. Please contact your AAMS system administrator!');
              this.needAamsAuth = true;
              return;
          }
          if (data.isActive == false) {
            alert("Your user account is NOT active. Please contact your AAMS system administrator!");
            this.needAamsAuth = true;
            return;
          }
          validUser = data;
          let isFirstLogin = validUser.firstLoginDt ? '0': '1';
          // FOR TESTING ONLY!!
          // isFirstLogin = "1";
          // const userType = validUser.userType;
          this._myUser = {
            userRole: validUser.userType,
            userName: validUser.userName,
            email: validUser.emailAddress
          }
          this.utilService.doAudit(isFirstLogin, 'isFirstLogin:');
          //
          this.cookieService.set('userRole', validUser.userType, 1, '/');
          this.cookieService.set('userName', validUser.emailAddress, 1, '/');
          this.cookieService.set('whoami', validUser.id, 1, '/');
          this.cookieService.set('isFirstLogin', isFirstLogin, 1, '/');
          this.utilService.saveSecLevel(validUser.userType);    // change security level in service to let TopBar Component know there was a change
          this.needAamsAuth = false;
          let eventUser = {
            userName: validUser.emailAddress,
            userRole: validUser.userType,
            isFirstLogin: isFirstLogin
          }
          this.utilService.doAudit(eventUser, 'triggering Login event for eventUser:');
          this.eventEmitter.triggerLoginEvent(eventUser); // let the Home component know we got the user info
        });
      }
    }
    // allow access IFF option's security level is GREATER THAN/EQUAL TO the user's security level
    // security levels for Clerk of the Board and staff:  1-10; for Assessor's staff: 11-20
    allowAccess(level: number) {
      const userSecLevel = this.utilService.getSecLevel();
      // this.utilService.doAudit(level + '; ' + userSecLevel, 'allow Access');
      if (this.utilService.isDeveloper()) { return true;}
      if (level === 99) { return false; } // level 99 is for developers ONLY!!
      if (userSecLevel <= level) { return true; }
      else { return false; }
    }
    // determine access for assessors based on their security level
    assessorAccess(level: number) {
      const userSecLevel = this.utilService.getSecLevel();
      // this.utilService.doAudit(level + '; ' + userSecLevel, 'allow Access');
      if (this.utilService.isDeveloper()) { return true;}
      if (level === 99) { return false; } // level 99 is for developers ONLY!!
      return userSecLevel == level;
    }
    // explicitly DENY access to option IFF user's security level is LESS THAN option's sec level
    // security levels for Administrator and Clerk of the Board staff:  1-10; for Assessor's staff: 11-20
    denyAccess(level: number): boolean {
      const userSecLevel = this.utilService.getSecLevel();
      // this.utilService.doAudit(level + '; ' + userSecLevel, 'deny Access');
      //
      if (this.utilService.isDeveloper() == true) { return false; } // developers should have access, by default...
      // this.utilService.doAudit('not an dev', 'got here');
      if (userSecLevel > level ) { return true; }
      else { return false; }
    }
    continue() {
        let retUrl = theGlobals.auth0RedirectUrl;
        const curUrl = window.location.hostname;

        if (curUrl.indexOf('localhost') >= 0) {
            retUrl = 'http://localhost:4200';
          }
        window.location.replace(retUrl);
    }
}
